/**
 * 刷新到最新版本的工具函数
 * 在刷新前先注销所有 Service Worker，确保下次加载走真实网络
 */
export async function refreshToLatest(): Promise<void> {
  // 清除新版本可用标志
  try {
    localStorage.removeItem('sw_has_update_available');
  } catch (error) {
    console.warn('[Refresh] Failed to clear update flag:', error);
  }

  // 设置刷新标记，防止刷新后立即检测到更新
  try {
    sessionStorage.setItem('sw_refreshing', 'true');
    // 设置一个时间戳，表示刷新操作的时间
    sessionStorage.setItem('sw_refresh_time', Date.now().toString());
  } catch (error) {
    console.warn('[Refresh] Failed to set refresh flag:', error);
  }

  // 先注销所有 Service Worker
  if ('serviceWorker' in navigator) {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const r of regs) {
        await r.unregister();
        console.log('[Refresh] Unregistered Service Worker:', r.scope);
      }
    } catch (error) {
      console.warn('[Refresh] Failed to unregister Service Workers:', error);
      // 即使注销失败，也继续刷新
    }
  }
  
  // 刷新页面
  window.location.reload();
}

